// export default () => ({
// })

export default () => ({
    sites: [],
    sitesSelectable: [],
    sitesPaginatedData: null,
    site: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})